module.exports = __webpack_public_path__ + "static/media/w_pawn.4835c015.png";